import type { CSSProperties } from "react";

/** Mount for the shared "Jules Tools" menu. The dropdown itself — tool list, per-person
    favourites, data-lineage viewer — is rendered into this element by nav.js, loaded
    from the hub in index.html. The link inside is the fallback: nav.js hides it once it
    has run, so it is only ever visible if the script never loads (cvp down, a 404), and
    the header still has its way out. */
const TRIGGER_STYLE = { "--jn-font-size": "11px", "--jn-font-weight": "500" } as CSSProperties;

export function ToolsNav() {
  return (
    <div data-jules-nav style={TRIGGER_STYLE}>
      <a
        href="https://cvp.julianfife.com"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-1.5 rounded-md border border-line px-3 py-1.5 font-mono text-[11px] uppercase tracking-[0.1em] text-ink-soft transition-colors hover:border-line-strong hover:bg-paper hover:text-ink"
      >
        Jules Tools
      </a>
    </div>
  );
}
